import Swiper from "swiper/bundle";
import 'swiper/css/bundle';

export default function PARTY() {
  let retryCount = 0;

  const initSwiper = () => {
    const target = document.querySelector('.party_slide');
    
    if (!target) {
      // まだHTMLがない場合は、最大20回（合計2秒間）まで 0.1秒おきに探す
      if (retryCount < 20) {
        retryCount++;
        setTimeout(initSwiper, 100);
      }
      return;
    }

    new Swiper(target, {
      observer: true,
      observeParents: true,
      loop: true,
      slidesPerView: 1,   
      // autoplay: {
      //   delay: 3000,             // 3秒ごとに切り替え（3000ms）
      //   disableOnInteraction: false, // ユーザーが手動で操作した後も自動再生を続ける
      // },
            // 画面に1枚だけ表示
      centeredSlides: false,    // 1枚表示なら中央寄せ設定は不要
      spaceBetween: 0,          // スライド間の隙間も不要なら0に
      
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // ブレイクポイントも1枚表示に統一
      breakpoints: {
        900: {
          slidesPerView: 1,
          spaceBetween: 0,
        }
      }
    });
    console.log('PARTYスライダーを初期化しました');
  };

  initSwiper();
}